import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { SubscriptionLinkedSubscriptionsSerializer } from './subscription-linked-subscriptions.serializer'
import { SubscriptionLinkedSubscriptions } from './subscription-linked-subscriptions'
import { ResourceService } from 'src/app/shared/resource-service'
import { environment } from 'src/environments/environment'

@Injectable()
export class SubscriptionLinkedSubscriptionsService extends ResourceService<SubscriptionLinkedSubscriptions> {
  constructor(
    private http: HttpClient,
    private subscriptionLinkedSubscriptionsSerializer: SubscriptionLinkedSubscriptionsSerializer
  ) {
    super(
      http,
      `${environment.backendApiUrl}/subscription-linked-subscriptions`,
      subscriptionLinkedSubscriptionsSerializer
    )
  }
}
